import $ from 'jquery';
export default function tuitionCalculator() {
    var data = [
        {"id": 1, "Name": "ALBANY CITY SD", "Tuition": "$19,196"},
        {"id": 2, "Name": "AMHERST CSD", "Tuition": "$12,935"},
        {"id": 3, "Name": "AMSTERDAM CITY SD", "Tuition": "$12,930"},
        {"id": 4, "Name": "ARLINGTON CSD", "Tuition": "$14,854"},
        {"id": 5, "Name": "AVERILL PARK CSD", "Tuition": "$12,211"},
        {"id": 6, "Name": "BALLSTON SPA CSD", "Tuition": "$14,902"},
        {"id": 7, "Name": "BEACON CITY SD", "Tuition": "$15,281"},
        {"id": 8, "Name": "BETHLEHEM CSD", "Tuition": "$14,818"},
        {"id": 9, "Name": "BRIGHTON CSD", "Tuition": "$16,312"},
        {"id": 10, "Name": "BRUNSWICK CSD (BRITTONKILL)", "Tuition": "$13,312"},
        {"id": 11, "Name": "BUFFALO CITY SD", "Tuition": "$16,140"},
        {"id": 12, "Name": "CENTRAL ISLIP UFSD", "Tuition": "$24,990"},
        {"id": 13, "Name": "CHEEKTOWAGA CSD", "Tuition": "$13,092"},
        {"id": 14, "Name": "CHEEKTOWAGA-MARYVALE UFSD", "Tuition": "$14,543"},
        {"id": 15, "Name": "CHEEKTOWAGA-SLOAN UFSD", "Tuition": "$13,791"},
        {"id": 16, "Name": "CHURCHVILLE-CHILI CSD", "Tuition": "$12,460"},
        {"id": 17, "Name": "CLEVELAND HILL UFSD", "Tuition": "$14,094"},
        {"id": 18, "Name": "COHOES CITY SD", "Tuition": "$16,031"},
        {"id": 19, "Name": "CORTLAND CITY SD", "Tuition": "$13,403"},
        {"id": 20, "Name": "DEPEW UFSD", "Tuition": "$12,663"},
        {"id": 21, "Name": "EAST GREENBUSH CSD", "Tuition": "$15,321"},
        {"id": 22, "Name": "EAST IRONDEQUOIT CSD", "Tuition": "$15,028"},
        {"id": 23, "Name": "ELMIRA CITY SD", "Tuition": "$13,435"},
        {"id": 24, "Name": "FRONTIER CSD", "Tuition": "$11,168"},
        {"id": 25, "Name": "GATES CHILI CSD", "Tuition": "$13,560"},
        {"id": 26, "Name": "GENESEO CSD", "Tuition": "$15,393"},
        {"id": 27, "Name": "GREECE CSD", "Tuition": "$14,401"},
        {"id": 28, "Name": "GREEN ISLAND UFSD", "Tuition": "$17,692"},
        {"id": 29, "Name": "GREENVILLE CSD", "Tuition": "$16,448"},
        {"id": 30, "Name": "GUILDERLAND CSD", "Tuition": "$14,793"},
        {"id": 31, "Name": "HAMBURG CSD", "Tuition": "$13,820"},
        {"id": 32, "Name": "HEMPSTEAD UFSD", "Tuition": "$28,487"},
        {"id": 33, "Name": "HOMER CSD", "Tuition": "$14,461"},
        {"id": 34, "Name": "HOOSIC VALLEY CSD", "Tuition": "$13,607"},
        {"id": 35, "Name": "HUDSON CITY SD", "Tuition": "$16,863"},
        {"id": 36, "Name": "HYDE PARK CSD", "Tuition": "$15,585"},
        {"id": 37, "Name": "ITHACA CITY SD", "Tuition": "$17,490"},
        {"id": 38, "Name": "KENMORE-TONAWANDA UFSD", "Tuition": "$12,470"},
        {"id": 39, "Name": "KINDERHOOK CSD", "Tuition": "$13,688"},
        {"id": 40, "Name": "LACKAWANNA CITY SD", "Tuition": "$15,553"},
        {"id": 41, "Name": "LANCASTER CSD", "Tuition": "$11,591"},
        {"id": 42, "Name": "LANSINGBURGH CSD", "Tuition": "$14,839"},
        {"id": 43, "Name": "MARLBORO CSD", "Tuition": "$19,896"},
        {"id": 44, "Name": "MECHANICVILLE CITY SD", "Tuition": "$16,059"},
        {"id": 45, "Name": "MENANDS UFSD", "Tuition": "$18,501"},
        {"id": 46, "Name": "MT VERNON SCHOOL DISTRICT", "Tuition": "$19,683"},
        {"id": 47, "Name": "NEWBURGH CITY SD", "Tuition": "$20,235"},
        {"id": 48, "Name": "NIAGARA FALLS CITY SD", "Tuition": "$14,206"},
        {"id": 49, "Name": "NIAGARA-WHEATFIELD CSD", "Tuition": "$12,823"},
        {"id": 50, "Name": "NISKAYUNA CSD", "Tuition": "$15,495"},
        {"id": 51, "Name": "NORTH COLONIE CSD", "Tuition": "$14,681"},
        {"id": 52, "Name": "NORTH TONAWANDA CITY SD", "Tuition": "$12,023"},
        {"id": 53, "Name": "NYC CHANCELLOR'S OFFICE", "Tuition": "$19,905"},
        {"id": 54, "Name": "POUGHKEEPSIE CSD", "Tuition": "$18,612"},
        {"id": 55, "Name": "RAVENA-COEYMANS-SELKIRK CSD", "Tuition": "$15,336"},
        {"id": 56, "Name": "RENSSELAER CITY SD", "Tuition": "$12,105"},
        {"id": 57, "Name": "RIVERHEAD CSD", "Tuition": "$24,055"},
        {"id": 58, "Name": "ROCHESTER CITY SD", "Tuition": "$14,277"},
        {"id": 59, "Name": "ROOSEVELT UFSD", "Tuition": "$22,043"},
        {"id": 60, "Name": "RUSH-HENRIETTA CSD", "Tuition": "$15,964"},
        {"id": 61, "Name": "SCHALMONT CSD", "Tuition": "$15,614"},
        {"id": 62, "Name": "SCHENECTADY CITY SD", "Tuition": "$16,279"},
        {"id": 63, "Name": "SCHODACK CSD", "Tuition": "$16,313"},
        {"id": 64, "Name": "SCHOHARIE CSD", "Tuition": "$15,251"},
        {"id": 65, "Name": "SCOTIA-GLENVILLE CSD", "Tuition": "$14,125"},
        {"id": 66, "Name": "SHENENDEHOWA CSD", "Tuition": "$14,350"},
        {"id": 67, "Name": "SILVER CREEK CSD", "Tuition": "$16,425"},
        {"id": 68, "Name": "SOUTH COLONIE CSD", "Tuition": "$15,796"},
        {"id": 69, "Name": "SPACKENKILL UFSD", "Tuition": "$19,218"},
        {"id": 70, "Name": "SPENCERPORT CSD", "Tuition": "$13,822"},
        {"id": 71, "Name": "SWEET HOME CSD", "Tuition": "$16,174"},
        {"id": 72, "Name": "SYRACUSE CITY SD", "Tuition": "$15,472"},
        {"id": 73, "Name": "TONAWANDA CITY SD", "Tuition": "$12,751"},
        {"id": 74, "Name": "TROY CITY SD", "Tuition": "$19,181"},
        {"id": 75, "Name": "UNIONDALE UFSD", "Tuition": "$26,093"},
        {"id": 76, "Name": "UTICA CITY SD", "Tuition": "$13,494"},
        {"id": 77, "Name": "VOORHEESVILLE CSD", "Tuition": "$16,062"},
        {"id": 78, "Name": "WAPPINGERS CSD", "Tuition": "$14,804"},
        {"id": 79, "Name": "WATERFORD-HALFMOON UFSD", "Tuition": "$21,974"},
        {"id": 80, "Name": "WATERVLIET CITY SD", "Tuition": "$13,237"},
        {"id": 81, "Name": "WEBSTER CSD", "Tuition": "$14,786"},
        {"id": 82, "Name": "WEST IRONDEQUOIT CSD", "Tuition": "$14,477"},
        {"id": 83, "Name": "WEST SENECA CSD", "Tuition": "$13,250"},
        {"id": 84, "Name": "WILLIAMSVILLE CSD", "Tuition": "$13,204"},
        {"id": 85, "Name": "WYANDANCH UFSD", "Tuition": "$22,516"},
        {"id": 86, "Name": "WYNANTSKILL UFSD", "Tuition": "$15,246"},
        {"id": 87, "Name": "YONKERS CITY SD", "Tuition": "$19,205"},
        {"id": 88, "Name": "YORKSHIRE-PIONEER CSD", "Tuition": "$12,650"}
    ];

    var val = 0;
    var total = 0;
        function formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }

    $.each(data, function(i, option) {
        $('#sel').append($('<option/>').attr("value", option.id).text(option.Name));
    });

    $("#add").click(function() {
        $.each(data, function(i, option) {
            if (option.id == $('#sel option:selected').val()) {
                val++;
                $('#tuitiontable tr:last').after('<tr><td>' + option.Name + '</td><td>' + option.Tuition + '</td><td><input class="qty" type="text" data-tuition="' + option.Tuition + '" data-val="' + val + '"></td><td data-total="' + val + '"></td></tr>');
                if (option.id == 53) {
                    $("#nyc").show();
                }
                return false;
            }
        });
    });

    $(document).on('change', '.qty', function() {
        let marker = $(this).data("val");
        let oldtotal = $('[data-total="' + marker + '"]').html();
        if (oldtotal == "") {
            oldtotal = 0;
        } else {
            oldtotal = parseFloat(oldtotal.replace(/\$|,/g, ''));
        }
        let tuition = parseFloat($(this).data("tuition").replace(/\$|,/g, ''));
        let districttuition = tuition * $(this).val();
        total = total - oldtotal + districttuition;
        $('[data-total="' + marker + '"]').html("$" + formatNumber(districttuition));
        $('#total').html("$" + formatNumber(total));
    });
}